/**
* Calendar factory which returns a Javascript object which
* represents the days and weeks which make up a calendar month
* surrounding a provided date.
*
* @class Calendar
*/
var Calendar = function () {
	var self = this;

	/**
	* The week template contains a simple construct for the
	* days in that week of the month called for, and the
	* week number of the year. Each day in the days collection
	* is a native Javascript Date object.
	*/
	self.weekTemplate = function () {
		return {
			days: []
		};
	};


	/**
	* The month template contains a simple construct for the
	* weeks in the month called for. All properties of the month
	* can be derived from the native Javascript Date objects
	* in weeks -> days
	*/
	self.monthTemplate = function () {
		return {
			weeks: []
		};
	};


	/**
	* This is the primary method for the Calendar factory.
	* If provided, a calendar month will be built around a date.
	* If not provided, the current calendar month will be created.
	*
	* @method buildMonth
	* @param {Date} [dRequestedDate] A date contained within the calendar month
	* @return {Object} Returns a javascript object representing the months/days
	*/
	self.buildMonth = function ( dRequestedDate ) {
		var dDate = new moment( dRequestedDate ),   // Attempt to derive a date from the string
			dt = null,
			iNumberOfDaysInMonth = null,
			rMonth = new self.monthTemplate(),
			week = new self.weekTemplate();

		// If we did not parse a Date, or dRequestedDate is null, we will
		// use today's date as a basis, otherwise we will create a new native
		// Date object with the return of Date.parse (which is the number of
		// milliseconds since epoch start)
		dDate = ( dDate.isValid() ) ? dDate : new moment();

		// Understand how many days are in the month so we can easily iterate
		// over each day to add them to collections
		iNumberOfDaysInMonth = dDate.daysInMonth();

		// Iterate over each day of the month
		for ( i = 1; i <= iNumberOfDaysInMonth; i++) {

			// Create a new native moment object, and initialize it with dDate
			// Since dDate has been set to the first day in the month and we
			// know how many days there are in this month, we can create this
			// initialized date on each iteration and just increment the day
			// by i.
			dt = new moment( dDate );
			dt.date( i );
			dt.hours( 0 );
			dt.minutes( 0 );
			dt.seconds( 0 );

			// Add the day to the week's 'days' array
			week.days.push( dt );

			// If we have reached Saturday, we will finish up the week, add
			// it to the month, and prepare a new week for the next iteration.
			// This logic will also run if we are at the last day of the month
			// (but not necessarily on a Saturday) as the week needs to get
			// pushed to the month before we end the iteration and lose the
			// week variable
			if ( dt.day() == 6 || i == iNumberOfDaysInMonth ) {

				// Add the week to the month's 'weeks' array
				rMonth.weeks.push( week );

				// It's Saturday, so pack up the week and re-instantiate
				week = new self.weekTemplate();
			}
		}

		// Finally return the completed month object
		return rMonth;

	};


	// Initialize Calendar by calling it's buildMonth method
	if ( arguments.length > 0 ) {
		return self.buildMonth( arguments[0] );
	}
	else {
		return self.buildMonth();
	}

	return self;
};